import 'slick-carousel/';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


$(function(){
    $('.slider').slick({
        dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,


    });

    
});

